export const STATE_LS_KEY = 'taxAuthState';

export enum ResultCodes {
  Success = 0,
  ExpiredUrl = 501,
  MissingUrlParams = 601,
}
